export enum PdfSettingsProductIdTypeEnum {
  INTERNAL = 'INTERNAL',
  MANUFACTURER = 'MANUFACTURER',
  EAN = 'EAN',
}
